import { render, staticRenderFns } from "./IconPoiGas.vue?vue&type=template&id=3057f39a&"
import script from "./IconPoiGas.vue?vue&type=script&lang=js&"
export * from "./IconPoiGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports